/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicVirtualMachinesAgents extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicVirtualMachinesAgents");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicVirtualMachinesAgents.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicVirtualMachinesAgents>): BackgroundJobPayloadForPeriodicVirtualMachinesAgents {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicVirtualMachinesAgents(), model);
        BackgroundJobPayloadForPeriodicVirtualMachinesAgents.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicVirtualMachinesAgents>): BackgroundJobPayloadForPeriodicVirtualMachinesAgents {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicVirtualMachinesAgents.newInstance(<BackgroundJobPayloadForPeriodicVirtualMachinesAgents> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicVirtualMachinesAgents) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicVirtualMachinesAgents.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicVirtualMachinesAgents): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicVirtualMachinesAgents.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
